import type { APIClient } from "@heidelbergmaterials/fcl-apiclient"

import { User, UserPermission } from "./types"

export type { User, UserPermission } from "./types"

export const getUserById = (apiClient: APIClient, id: string): Promise<User> =>
	apiClient.get(`/users/${id}`).then(response => response.data)

export const updateUserById = (
	apiClient: APIClient,
	id: string,
	patch: Partial<User>,
): Promise<User> =>
	apiClient.patch(`/users/${id}`, patch).then(response => response.data)

export const getPermissionsByUserId = (
	apiClient: APIClient,
	userId: string,
): Promise<UserPermission[]> =>
	apiClient
		.get("/permissions", { params: { userId } })
		.then(response => response.data)
